export const HUGE:any = (()=>{const s='xxxxxxxxxxxxxxx'; return s;})();
